export const ROUTES = {
  // Public
  LOGIN: '/',
  DEMO: '/demo',
  ACCESS_EXPIRED: '/access-expired',

  // Onboarding steps (protected)
  ONBOARDING: {
    ONBOARDING_SURVEY: '/survey',
    WELCOME: '/onboarding/welcome',
    LISTENING_TEST: '/onboarding/listening-test',
    MICROPHONE_PERMISSION: '/onboarding/microphone-permission',
    RECORDING_TEST: '/onboarding/recording-test',
    VIDEO_TEST: '/onboarding/video-test',
    READY_TO_START: '/onboarding/ready',
    TIMER_TIP: '/onboarding/timer-tip'
  },

  // Testing (protected)
  TESTING: {
    ICEBREAKER: '/icebreaker',
    TEST: '/testing'
  },
  PROCESSING: '/processing',
  COMPLETED: '/completed',

  // Results (protected)
  RESULTS: '/result',
  RESULTS_EXPORT: '/result/export'
} as const
